import React, { useEffect, useState } from 'react';
import styles from './AddMenuDay.module.css';
import AddMeal from '../AddMeal/AddMeal';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoaderPage from '../LoaderPage/LoaderPage';
import { addMenuBd, getGrupListDb } from '../../firebase';
import { addNumberDayRedux, resetMenuDay } from '../../store/slices/menuSlice';
import { getGroupName } from '../../helperProject';
import { addGroupRedux } from '../../store/slices/groupsSlice';
import TrainingSelector from '../TrainingSelector/TrainingSelector';

export default function AddMenuDay() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const menuDay = useSelector((state) => state.menu.menuDay);
  const groups = useSelector((state) => state.groups.groupsList);

  let { group_id } = useParams();
  const [loader, setLoader] = useState(false);

  // console.log(menuDay);

  const saveMenuBd = async (group_id, menuDay, groupName) => {
    // console.log(menuDay);

    if (groupName) {
      setLoader(true);
      await addMenuBd(group_id, menuDay, groupName);
      setLoader(false);
      // navigate('/appnkadmin/menu/' + group_id);
    } else {
      alert('Відсутнє імя групи.');
    }
  };

  useEffect(() => {
    if (!groups.length) {
      setLoader(true);
      const fetchData = async () => {
        const groupsListArray = await getGrupListDb();
        dispatch(addGroupRedux(groupsListArray));
        setLoader(false);
      };
      fetchData();
    }
  }, []);

  const addNumberDay = (inputValue) => {
    if (Number(inputValue) > 0 || inputValue === '') {
      if (Number(inputValue) < 2) {
        if (
          menuDay.breakfast.repeatMenu ||
          menuDay.snack.repeatMenu ||
          menuDay.dinner.repeatMenu ||
          menuDay.supper.repeatMenu
        ) {
          let isAddNumberDay = window.confirm('Всі вчорашні прийоми їжі будуть відмінені! ');
          if (isAddNumberDay) {
            dispatch(addNumberDayRedux(inputValue));
          }
          return;
        }
      }
      dispatch(addNumberDayRedux(inputValue));
    }
  };

  return (
    <div className={styles.menuDay_wrapper}>
      <div className={styles.numberDay_wrapper}>
        <h3 className={styles.numberDay_title}>День № </h3>
        <input
          type="number"
          className={styles.input_NumberDay}
          placeholder="Цифра..."
          value={menuDay.dayNumber}
          onChange={(e) => addNumberDay(e.target.value.trim())}
        />
      </div>
      <TrainingSelector trainingObjectProps={menuDay.training} />
      <AddMeal mealName="breakfast" />
      <AddMeal mealName="snack" />
      <AddMeal mealName="dinner" />
      <AddMeal mealName="supper" />
      <button
        className={styles.save_btn}
        onClick={() => saveMenuBd(group_id, menuDay, getGroupName(groups, group_id))}>
        Зберегти
      </button>
      {loader && <LoaderPage />}
    </div>
  );
}
